module.exports = __webpack_public_path__ + "static/media/logo.69670648.svg";